module.exports = __webpack_public_path__ + "img/1.ad4072a5.png";